import styled from "styled-components";
import { palette } from "styled-theme";

const HouseVisitWrapper = styled.div`
  max-height: calc(90vh);

  .modalHeader {
    display: flex;
    justify-content: space-between;
    background-color: ${palette("surfaceColor", 0)};
    padding: 10px;
    .save {
      margin: 0 10px;
    }
    border-bottom: 1px solid ${palette("border", 0)};
  }
  .formBody {
    max-height: calc(90vh - 54px);

    overflow: auto;
  }
  .ant-select-single .ant-select-selector,
  .ant-picker-input > input[disabled],
  .ant-radio-disabled + span,
  .ant-input-disabled,
  .ant-input[disabled] {
    color: initial !important;
  }
`;

export default HouseVisitWrapper;
